import axios from 'axios';
import stringToBoolean from '@/common/stringToBoolean';
import { getConfigProperty } from '@/common/oldMobile';

axios.defaults.withCredentials = stringToBoolean(getConfigProperty('xhrWithCredentials'));

axios.defaults.transformResponse = [
    function(data) {
        // axios defaultne nethrowuje error pokial nedokaze sparsovat odpoved, hmm ...
        // zacinam rozmyslat ci bola axios dobra volba, hmm ...
        if (typeof data === 'string' && data !== '') {
            try {
                data = JSON.parse(data);
            } catch (e) {
                console.warn('This data from axios call can not be parsed to JSON, you should check it out.', data);
            }
        }
        return data;
    }
];

// my pouzivame ajax volanie tak ze to resolnutej promisy sa dostava priamo json payload
axios.interceptors.response.use(response => {
    const data = response.data;
    // console.warn('axios response', data);
    // processing legacy nike formularov (ReactFormDTO)
    if (data && data._legacy) {
        if (data.sessionExpired) {
            return Promise.reject({
                _legacy: true,
                _sessionExpired: true,
                response: response
            });
        }
        if (data.errors && data.errors.MASTER_ERROR) {
            return Promise.reject({
                _legacy: true,
                _masterError: data.errors.MASTER_ERROR,
                _errors: data.errors,
                response: response
            });
        }
        if (data.errors) {
            return Promise.reject({
                _legacy: true,
                _fieldErrors: data.errors,
                _errors: data.errors,
                response: response
            });
        }
    }
    return data;
});

axios.__nike_setup = true;
